module.exports = __webpack_public_path__ + "static/media/c-sm-logo.bed6b4e9.png";